import { render, staticRenderFns } from "./housingTotal.vue?vue&type=template&id=2e48676e&scoped=true"
import script from "./housingTotal.vue?vue&type=script&lang=js"
export * from "./housingTotal.vue?vue&type=script&lang=js"
import style0 from "./housingTotal.vue?vue&type=style&index=0&id=2e48676e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e48676e",
  null
  
)

export default component.exports